import { toast } from "react-toastify";
import { GET } from "../../../services/api";
import { ApiUrl } from "../../../ApiHelper/ApiUrl";

export const mySubscription = () => async (isLoading) => {
  try {
    const res = await GET(`${ApiUrl.CLIENT_SUBSCRIPTION_GET}`);
    if (res?.data?.code === 200) {
      return res.data?.result;
    } else {
      toast.error(res?.data?.message);
      return null;
    }
  } catch (error) {
    toast.error("Failed to fetch subscription data");
    return null;
  }
};
